
import { apiService } from '../config/api'; 

export class SharePointManager {
  constructor() {
    this.baseUrl = 'https://graph.microsoft.com/v1.0';
    this.uploadUrl = 'https://graph.microsoft.com/v1.0/sites/15b5e57a-d260-4719-b760-b35f8bd397e7/drives/b!euW1FWDSGUe3YLNfi9OX51_68aIy25VKgum0tQlxVPWASbKfHkF6TLLyISs-shsr/root:/';
    this.token = null;
    this.tenantId = process.env.REACT_APP_TENANT_ID;
  }

  async initialize() {
    try {
      await this.getToken();
    } catch (error) {
      throw error;
    }
  }

  async getToken() {
    try {
      if (!this.tenantId) {
        throw new Error('tenantId is required');
      }

      const data = await apiService.microsoft.getToken(this.tenantId);
      
      if (!data.accessToken) {
        throw new Error('No accessToken in response');
      }
      
      this.token = data.accessToken;
    } catch (error) {
      throw error;
    }
  }

  async uploadFile(file, cod_representante, nombre_representante) {
    try {
      if (!this.token) {
        await this.initialize();
      }
      
      const fileExtension = file.name.split('.').pop();
      const fileName = `${cod_representante} - ${nombre_representante}.${fileExtension}`;
      
      let response = await this.makeUploadRequest(file, fileName);
  
      if (response.status === 401) {
        await this.getToken();
        response = await this.makeUploadRequest(file, fileName); 
      }

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return {
        webUrl: data.webUrl,
        fileName: fileName
      };
    } catch (error) {
      throw error;
    }
  }

  async makeUploadRequest(file, fileName) {
    return fetch(`${this.uploadUrl}${fileName}:/content`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${this.token}`,
        "Content-Type": file.type,
      },
      body: file,
    });
  }
}

export default SharePointManager;